"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getCollegeTitle = function getCollegeTitle(student) {
  if (!(0, _isEmpty.default)(student.d1Athletics) && student.d1Athletics[0].isDivisionOne) {
    return 'Division 1 Athletics';
  }
  return 'Collegiate Athletics';
};
var _default = getCollegeTitle;
exports.default = _default;